/*eslint  @typescript-eslint/no-use-before-define: 0*/

import { defineModule } from "direct-vuex";
import { moduleActionContext, moduleGetterContext } from "@/store";
import { getUpdateExtendPairData, saveExtendPairCostDocumentItemWithDocumentItem } from "@/requests/costDocument";
import { UpdateExtendPairData } from "@/models/api/costDocuments/UpdateExtendPairData";
import { ExtendCostDocumentItemPair } from "@/models/api/costDocuments/ExtendCostDocumentItemPair";
import { DocumentItemToPair } from "@/models/api/costDocuments/DocumentItemsToPair";

export interface CostDocumentsAdvancedPairingStateInterface {
  advancedPairingDocumentItemId: null | string;
  advancedPairingAmount: number;
  advancedPairingData: null | UpdateExtendPairData;
  advancedPairingIsCurrencyDifferences: boolean;
  advancedPairingAmountToSetAsExchangeDifferences: number;
}

export const CostDocumentsAdvancedPairingState: CostDocumentsAdvancedPairingStateInterface = {
  advancedPairingDocumentItemId: null,
  advancedPairingAmount: 0,
  advancedPairingData: null,
  advancedPairingIsCurrencyDifferences: false,
  advancedPairingAmountToSetAsExchangeDifferences: 0,
};

const CostDocumentsAdvancedPairingModule = defineModule({
  state: CostDocumentsAdvancedPairingState as CostDocumentsAdvancedPairingStateInterface,
  namespaced: true as const,
  getters: {},
  mutations: {
    setAdvancedPairingDocumentItemId(state, param: null | string) {
      state.advancedPairingDocumentItemId = param;
    },
    setAdvancedPairingAmount(state, amount: number) {
      state.advancedPairingAmount = amount;
    },
    setAdvancedPairingData(state, data: null | UpdateExtendPairData) {
      state.advancedPairingData = data;
      if (data !== null) {
        state.advancedPairingIsCurrencyDifferences = data.isCurrencyDifferences;
        state.advancedPairingAmountToSetAsExchangeDifferences = data.extendPairCostDifference;
      }
    },
    setAdvancedPairingIsCurrencyDifferences(state, param: boolean) {
      state.advancedPairingIsCurrencyDifferences = param;
    },
    setAdvancedPairingAmountToSetAsExchangeDifferences(state, param: number) {
      state.advancedPairingAmountToSetAsExchangeDifferences = param;
    },
  },
  actions: {
    async openAdvancedPairingDialog(context, documentItem: DocumentItemToPair) {
      const { commit, state, rootState } = _moduleActionContext(context);
      commit.setAdvancedPairingAmount(documentItem.pairAmount);
      commit.setAdvancedPairingDocumentItemId(documentItem.id);
      const response = await getUpdateExtendPairData(
        rootState.costDocuments.pairing.costDocumentItemIdToPair as number,
        state.advancedPairingDocumentItemId as string,
        state.advancedPairingAmount
      );
      commit.setAdvancedPairingData(response);
    },
    async updatePairAmount(context, pairAmount: number) {
      const { commit, state, rootState, rootDispatch } = _moduleActionContext(context);
      await rootDispatch.failIfRequestsInProgress();
      commit.setAdvancedPairingAmount(pairAmount);
      const response = await getUpdateExtendPairData(
        rootState.costDocuments.pairing.costDocumentItemIdToPair as number,
        state.advancedPairingDocumentItemId as string,
        state.advancedPairingAmount
      );
      commit.setAdvancedPairingData(response);
    },
    async saveAdvancedPairing(context) {
      const { commit, state, rootState, rootDispatch } = _moduleActionContext(context);
      await rootDispatch.failIfRequestsInProgress();
      // eslint-disable-next-line
      let amount: string | number = state.advancedPairingAmount as any;
      if (typeof amount === "string") {
        amount = parseFloat(amount);
      }
      const extendCostDocumentItemPair = new ExtendCostDocumentItemPair();
      extendCostDocumentItemPair.isCurrencyDifferences = state.advancedPairingIsCurrencyDifferences;
      extendCostDocumentItemPair.pairAmount = amount as number;
      extendCostDocumentItemPair.amountToSetAsExchangeDifferences =
        state.advancedPairingAmountToSetAsExchangeDifferences;
      extendCostDocumentItemPair.documentItemId = state.advancedPairingDocumentItemId as string;
      extendCostDocumentItemPair.costDocumentItemId = rootState.costDocuments.pairing
        .costDocumentItemIdToPair as number;
      const response = await saveExtendPairCostDocumentItemWithDocumentItem(extendCostDocumentItemPair);
      rootDispatch.costDocuments.pairing.handlePairingResponse(response);
      commit.setAdvancedPairingDocumentItemId(null);
    },
  },
});

export default CostDocumentsAdvancedPairingModule;

/* eslint-disable */
// noinspection JSUnusedLocalSymbols
const _moduleGetterContext = (args: [any, any, any, any]) =>
  moduleGetterContext(args, CostDocumentsAdvancedPairingModule);
const _moduleActionContext = (context: any) =>
  moduleActionContext(context, CostDocumentsAdvancedPairingModule);
